import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    component: () => import('@/views/SplashScreenView.vue'),
    name: 'home',
  },
  {
    path: '/steps',
    component: () => import('@/views/PacksCreate.vue'),
    name: 'packs.create',
    redirect: { name: 'packs.onboarding' },
    children: [
      {
        path: '',
        component: () => import('@/views/PacksCreateOnboarding.vue'),
        name: 'packs.create.onboarding',
      },
      {
        path: 'packs/restore',
        component: () => import('@/views/PacksCreateRestore.vue'),
        name: 'packs.create.restore',
      },
      {
        path: 'packs/:packId?/collect/create/steps/one',
        component: () => import('@/views/PacksCreateStepOne.vue'),
        name: 'packs.create.steps[1]',
      },
      {
        path: 'packs/:packId/collect/create/steps/two',
        component: () => import('@/views/PacksCreateStepTwo.vue'),
        name: 'packs.create.steps[2]',
      },
      {
        path: 'packs/:packId/collect/create/steps/three',
        component: () => import('@/views/PacksCreateStepThree.vue'),
        name: 'packs.create.steps[3]',
      },
      {
        path: 'packs/:packId/items/:packItemId?',
        component: () => import('@/views/PacksCreateStepFour.vue'),
        name: 'packs.create.steps[4]',
      },
      {
        path: 'packs/:packId/five',
        component: () => import('@/views/PacksCreateStepFive.vue'),
        name: 'packs.create.steps[5]',
      },
      {
        path: 'packs/:packId/resume',
        component: () => import('@/containers/ResumeStepContainer.vue'),
        name: 'packs.create.resume',
      },
      {
        path: 'packs/:packId/confirm',
        component: () => import('@/views/PacksCreateConfirm.vue'),
        name: 'packs.create.confirm',
      },
      {
        path: 'packs/:packId/confirm_waste',
        component: () => import('@/views/PacksCreateConfirmWaste.vue'),
        name: 'packs.create.confirmWaste',
      },
    ],
  },
  {
    path: '/packs',
    component: () => import('@/views/PacksCancel/PacksCancel.vue'),
    children: [
      {
        path: ':packId?/collect/cancel/steps/one',
        component: () => import('@/views/PacksCancel/PacksCancelStepOne.vue'),
        name: 'packs.cancel.steps[1]',
      },
      {
        path: ':packId?/collect/cancel/steps/two',
        component: () => import('@/views/PacksCancel/PacksCancelStepTwo.vue'),
        name: 'packs.cancel.steps[2]',
      },
    ],
  },
  {
    path: '/receivers',
    component: () => import('@/views/ReceiversView.vue'),
    children: [
      {
        path: '',
        component: () => import('@/views/ReceiversSelect.vue'),
        name: 'receivers.select',
      },
      {
        path: ':receiverId/packs',
        component: () => import('@/views/ReceiversPacksHistory.vue'),
        name: 'receivers.packs',
      },
    ],
  },
  {
    path: '/packs/:packId/success',
    component: () => import('@/views/SuccessScreenView.vue'),
    name: 'packs.create.success',
  },
  {
    path: '/packs/:packId/success',
    component: () => import('@/views/SuccessScreenView.vue'),
    name: 'packs.create.collectAlreadClosed',
    props: { collectAlreadClosed: true },
  },
  {
    path: '/packs/:packId/collect/cancel/success',
    component: () => import('@/views/PacksCancel/PacksCancelSuccess.vue'),
    name: 'packs.cancel.success',
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});

export default router;
